import { HTMLAttributes } from 'react';

export default function Notice({
    className = '',
    children,
    ...props
}: HTMLAttributes<HTMLDivElement>) {
    return (
        <div className="px-10 py-6 border-brand-red border-b-2 bg-brand-yellow grid gap-4">
            <h2 className="flex gap-1.5 text-2xl font-semibold font-sans">
                <img src="/img/icons/xnix-line-eye.svg" />
                {props.title}
            </h2>
            {children}
        </div>
    );
}
